import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Trophy, Beer, Radio, Camera, ClipboardList, LogOut } from 'lucide-react';
import { OnPitchLogo } from './OnPitchLogo';

interface Props {
  adminName: string;
  onLogout: () => void;
}

const NAV_ITEMS = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/matches', icon: Trophy, label: 'Matchs' },
  { to: '/bars', icon: Beer, label: 'Bars' },
  { to: '/diffusions', icon: Radio, label: 'Diffusions' },
  { to: '/stories', icon: Camera, label: 'Stories' },
  { to: '/logs', icon: ClipboardList, label: 'Historique' },
];

export function Sidebar({ adminName, onLogout }: Props) {
  const initials = adminName
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .substring(0, 2);

  return (
    <aside className="sidebar">
      <div style={{ padding: '20px 24px 4px' }}>
        <OnPitchLogo height={28} />
      </div>
      <div className="sidebar-subtitle">Admin</div>

      <div className="sidebar-sep" />

      <nav className="sidebar-nav">
        {NAV_ITEMS.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
          >
            <item.icon size={18} />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="sidebar-bottom">
        <div className="sidebar-sep" />
        <div className="sidebar-user">
          <div className="avatar">{initials}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: '13px', fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{adminName}</div>
          </div>
          <button onClick={onLogout} className="btn-icon" title="Déconnexion">
            <LogOut size={16} />
          </button>
        </div>
      </div>
    </aside>
  );
}
